import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-24 bg-secondary-100/50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-label tracking-wider uppercase text-foreground-500">
              Trusted by Shoppers
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            What Our Community Says
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Thousands of shoppers use the Kakobuy Spreadsheet daily to discover amazing products.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`text-sm ${
                        i < t.rating
                          ? "ri-star-fill text-accent-500"
                          : "ri-star-line text-foreground-300"
                      }`}
                    ></i>
                  </span>
                ))}
              </div>
              <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                {t.headline}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={`${t.name} portrait`}
                  title={`${t.name} - ${t.role}`}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}